((Sliders, $) => {   

  const bindUIActions = () => {

    $('.js-home-best-sellers-tab-tiles-container').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  };   

  Sliders.init = () => {  
   bindUIActions();
  };

})(window.Sliders = window.Sliders || {}, jQuery);

